import React from "react";
import investorSustain from "../../../assets/investor/investor-sustain-2.png"
import { Link } from "react-router-dom";

function CorporateHomeSustain() {
    return (
        <>
        <div className="investor-hospital-container" style={{marginTop: "20px", marginBottom:"20px"}}>
                <img
                    src={investorSustain}
                    alt=""
                    style={{ width: "45%" }}
                />
                <div className="content-container">
                    <h2>
                        Our Sustainability
                    </h2>
                    <p>At KPJ, sustainability is at the core of our mission, guiding every step we take towards a greener, more responsible future.</p>
                    <Link to="https://kpj.listedcompany.com/sustainability.html" className="learn-more">
                        Learn More{" "}
                        <span>
                        <img
                            src="./../img/icon/56.png"
                            alt=""
                            className="learn-more-img"
                        />
                        </span>
                    </Link>
                </div>
        </div>
        </>
    )
}

export default CorporateHomeSustain;